<div fxLayout="column" class="neq-dialog">
  <div *ngIf="message" [innerHTML]="message"></div>

  <ul *ngIf="errorDetails">
    <li *ngFor="let errorDetail of errorDetails;">{{errorDetail}}</li>
  </ul>

  <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
    <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.ok' | translate}}" (click)="continue()"></button>
  </div>
</div>
